import { render, staticRenderFns } from "./crossCheckItemsMultiComparison.vue?vue&type=template&id=2981ded1&scoped=true&"
import script from "./crossCheckItemsMultiComparison.vue?vue&type=script&lang=js&"
export * from "./crossCheckItemsMultiComparison.vue?vue&type=script&lang=js&"
import style0 from "./crossCheckItemsMultiComparison.vue?vue&type=style&index=0&id=2981ded1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2981ded1",
  null
  
)

export default component.exports